import React from 'react';

// Import all steps.
import Welcome from './welcome';
import WebsiteType from './website-type';
import BusinessSearch from './business-search';
import CustomizeSite from './customize-site';
import IntelligentQuestions from './intelligent-questions';
import ImportSite from './import-site';
import BusinessInformation from './business-information';

export const STEPS = [
	{
		content: <Welcome />,
		class: 'step-welcome',
	},
	{
		content: <WebsiteType />,
		class: 'step-website-type',
	},
	{
		content: <BusinessSearch />,
		class: 'step-business-search',
	},
	{
		content: <BusinessInformation />,
		class: 'step-business-information',
	},
	{
		content: <IntelligentQuestions />,
		class: 'step-website-type',
	},
	{
		title: 'We are buiding your website...',
		content: <ImportSite />,
		class: 'step-import-site',
	},
	{
		content: <CustomizeSite />,
		class: 'step-customizer',
	}
];
